<template>
<!-- 为灵活信号设置页面提供列表上的展示选项，根据信号的name展示不同的para -->
  <div>
    <Row>
      <Col offset="1" span="22">
      <Row type="flex" justify="center">
        <Col v-for="row in columns" :key="row.title">
          <Tooltip transfer :content="row.title" :delay="500">
            <Button class="demo" :style="{color:row.color}">
                {{row.data}}
              </Button>
          </Tooltip>
        </Col>
      </Row>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "flexible_render_table_view",
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  methods:{
    }
};
</script>
<style>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>
